import { render, staticRenderFns } from "./upLoad2.vue?vue&type=template&id=dc7000cc&scoped=true&"
import script from "./upLoad2.vue?vue&type=script&lang=js&"
export * from "./upLoad2.vue?vue&type=script&lang=js&"
import style0 from "./upLoad2.vue?vue&type=style&index=0&id=dc7000cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc7000cc",
  null
  
)

export default component.exports